// creates a placeholder for the form
let t = (collection) => collection.items.map(data => `<div id="${data.id}" class="form-container"></div>`);

export = t;  